import { Dropdown, Button } from 'antd'
import { SunOutlined, MoonOutlined, DesktopOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { useThemeStore } from '@/store/theme'

const ICONS: Record<string, React.ReactNode> = {
  light: <SunOutlined />,
  dark: <MoonOutlined />,
  system: <DesktopOutlined />,
}

export function ThemeSwitcher() {
  const mode = useThemeStore((s) => s.mode)
  const resolved = useThemeStore((s) => s.resolved)
  const setMode = useThemeStore((s) => s.setMode)

  const items: MenuProps['items'] = [
    { key: 'light', icon: ICONS.light, label: 'Светлая' },
    { key: 'dark', icon: ICONS.dark, label: 'Тёмная' },
    { type: 'divider' },
    { key: 'system', icon: ICONS.system, label: 'Системная' },
  ]

  const handleClick: MenuProps['onClick'] = ({ key }) => {
    setMode(key as 'light' | 'dark' | 'system')
  }

  const currentIcon = mode === 'system' ? ICONS[resolved] : ICONS[mode]

  return (
    <Dropdown menu={{ items, onClick: handleClick, selectedKeys: [mode] }}>
      <Button type="text" icon={currentIcon} />
    </Dropdown>
  )
}
